
const searchResultsTracker = {

  marketSearchConversionId: null,
  ugsSearchConversionId: null,

  init: function() {
    this.setConversionIds();
    this.wireMarketSearchResultBars();
    this.wireUgsSearchResultBars();
    this.removeOriginParam();
  },

  setConversionIds: function() {
    const marketIdMetaTag = document.querySelector("meta[name='marketSearchConversionId']");
    const ugsIdMetaTag = document.querySelector("meta[name='ugsSearchConversionId']");

    this.marketSearchConversionId = marketIdMetaTag ? marketIdMetaTag.getAttribute("content") : null;
    this.ugsSearchConversionId = ugsIdMetaTag ? ugsIdMetaTag.getAttribute("content") : null;
  },

  wireMarketSearchResultBars: function() {
    const marketBars = document.querySelectorAll('.market-search-results .subject-bar.certified .subject-bar-link');

    if (marketBars.length > 0) {
      marketBars.forEach((marketBar, index) => {
        marketBar.addEventListener('click', (e) => this.handleSearchResultBarClick(e, 'market'));
      });
    }
  },

  wireUgsSearchResultBars: function() {
    const ugsBars = document.querySelectorAll('.market-search-results .subject-bar.ugs .subject-bar-link');

    if (ugsBars.length > 0) {
      ugsBars.forEach((ugsBar, index) => {
        ugsBar.addEventListener('click', (e) => this.handleSearchResultBarClick(e, 'ugs'));
      });
    }
  },

  handleSearchResultBarClick: function(e, barType) {
    e.preventDefault();
    e.stopPropagation();

    const bar = e.target;
    const barLink = bar.getAttribute('href');
    const resultId = bar.getAttribute('data-id');
    let searchConversionId; 

    // open window right away and then record search conversion
    const augmentedLink = barLink + '?origin=genome'; // see removeOriginParam below
    const newWindow = window.open(augmentedLink, '_self', 'noopener');

    if (barType == 'market' && this.marketSearchConversionId) {
      searchConversionId = this.marketSearchConversionId;
    } else if (barType == 'ugs' && this.ugsSearchConversionId) {
      searchConversionId = this.ugsSearchConversionId;
    }

    if (searchConversionId) {
      this.reportSearchConversion(resultId, searchConversionId).then((res) => {
        console.log('Search Conversion reported:', res);
      }).catch((err) => {
        console.log('Something went wrong with search conversion update. err:', err);
      });
    } else {
      console.log('No Search Conversion reported for this link:', barLink);
    }
  },

  reportSearchConversion: function(resultId, searchConversionId, callback) {
    const url = '/api/search_results/' + searchConversionId + '/result/' + resultId + '/convert';

    return fetch(url);
  },
  

  removeOriginParam() {
    // this process is necessary to support dual library styles. TODO: remove this and augmentedLink above after transitioning to new dashboard 
    let currentUrl = window.location.href;

    if (currentUrl.indexOf('?origin=genome') != -1) {
      currentUrl = currentUrl.split("?")[0];
      window.history.replaceState({}, document.title, currentUrl);
    }
  }
};

export default searchResultsTracker;
